import { Redirect, RouteProps } from 'react-router-dom';
import { useSelector } from 'react-redux';
import React, { FC } from 'react';
import { ServiceType, PortalTab } from '@idk-web/api';
import { SentryRoute } from '@/sentry';
import {
  selectPortalCompany,
  selectPortalLoginStatus,
} from '@/redux/portalAuth.slice';
import routes from '@/components/portal/routes';

export type UnauthenticatedRouteProps = RouteProps;

/**
 * A route which redirects to the portal app if the current user is logged in.
 */
const UnauthenticatedRoute: FC<UnauthenticatedRouteProps> = (props) => {
  const loginStatus = useSelector(selectPortalLoginStatus);
  const company = useSelector(selectPortalCompany);

  if (company && loginStatus === 'AUTHENTICATED') {
    const services = company.services.map((e) => e.type);
    const hasTeleId = services.includes(ServiceType.TELEID);
    const hasTeleSign = services.includes(ServiceType.TELESIGN);
    const hasSafeMail = services.includes(ServiceType.SAFEMAIL);

    if (company.defaultStartTab === PortalTab.TELEID && hasTeleId) {
      return <Redirect to={routes.teleid} />;
    } else if (company.defaultStartTab === PortalTab.TELESIGN && hasTeleSign) {
      return <Redirect to={routes.telesign} />;
    } else if (company.defaultStartTab === PortalTab.SAFEMAIL && hasSafeMail) {
      return <Redirect to={routes.safemail} />;
    } else if (company.defaultStartTab === PortalTab.ADMIN) {
      return <Redirect to={routes.admin} />;
    }

    if (hasTeleId) {
      return <Redirect to={routes.teleid} />;
    } else if (hasTeleSign) {
      return <Redirect to={routes.telesign} />;
    } else if (hasSafeMail) {
      return <Redirect to={routes.safemail} />;
    }

    return <Redirect to={routes.teleid} />;
  }

  return <SentryRoute {...props} />;
};

export default UnauthenticatedRoute;
